import React, { Component } from 'react';
// import clientApi from '../../api/client';
// import Toast from '../../utils/toast';
// import Load from '../../template/Load/Load';
// import {apiDefine} from '../../api/web'

import './ProgressBar.less';
class ProgressBar extends Component {
    render(){
        const {currentNum, totalNum, outColor, insertColor} = this.props;
        return(
            <div className="progress_bar" style={{backgroundColor:outColor}}>
                <div 
                    className="insert" 
                    style={{
                        backgroundColor: insertColor,
                        width: `${currentNum/totalNum * 100}%`
                    }}
                />
            </div>
        )
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/template/HomeworkNew/ProgressBar.jsx